var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "place place--float" },
    [
      _c("bk-search-field", {
        attrs: {
          icon: "gps_fixed",
          label: _vm.label,
          "helper-text": _vm.helperText,
          "watch-value": true,
          list: _vm.locations,
          valid: _vm.valid,
          id: _vm.id,
          loading: _vm.loading,
          "allow-hotjar-recording": _vm.allowHotjarRecording
        },
        on: {
          input: _vm.loadPlaceList,
          change: _vm.updateState,
          click: _vm.updateLocation
        },
        model: {
          value: _vm.searchTerm,
          callback: function($$v) {
            _vm.searchTerm = $$v
          },
          expression: "searchTerm"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }